const initialState = {
  localLocationMappingData: [],
  newLocationMappingInfo: null,
  isLocationUpdateInProgress: false,
  isOperationDelayed: false,
  drawingInProgress: false,
  isNewLocation: false,
  selectedLocationCardId: null,
  selectedFeatureIdsOnMap: null,
  isOverlappingRegions: false
};

const ACTION_TYPES = {
  SET_STATE_FROM_PROPS: 'SET_STATE_FROM_PROPS',
  HANDLE_DRAWING_UPDATE: 'HANDLE_DRAWING_UPDATE',
  UPDATE_CUSTOMERS_GEO_BOUNDARY: 'UPDATE_CUSTOMERS_GEO_BOUNDARY',
  SET_IS_OVERLAPPING_REGIONS: 'SET_IS_OVERLAPPING_REGIONS',
  SET_DRAWING_IN_PROGRESS: 'SET_DRAWING_IN_PROGRESS',
  SET_SELECTED_FEATURE_IDS_ON_MAP: 'SET_SELECTED_FEATURE_IDS_ON_MAP',
  SUBMIT_LOCATION_START: 'SUBMIT_LOCATION_START',
  SUBMIT_LOCATION_FINISH: 'SUBMIT_LOCATION_FINISH',
  OPERATION_DELAYED: 'OPERATION_DELAYED',
  OPEN_LOCATION_MAPPING_FORM: 'OPEN_LOCATION_MAPPING_FORM',
  CLOSE_FORM: 'CLOSE_FORM',
  SET_SELECTED_LOCATION_CARD_ID: 'SET_SELECTED_LOCATION_CARD_ID'
};

const locationMappingReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_STATE_FROM_PROPS:
      return { ...state, localLocationMappingData: action.payload };
    case ACTION_TYPES.HANDLE_DRAWING_UPDATE: {
      const { newLocationMappingInfo, isNewLocation } = action.payload;
      return { ...state, newLocationMappingInfo, isNewLocation };
    }
    case ACTION_TYPES.UPDATE_CUSTOMERS_GEO_BOUNDARY: {
      const { locationMappingId, boundary } = action.payload;
      const updatedLocationMappingData = [...state.localLocationMappingData];
      const matchedLocationIndex = updatedLocationMappingData.findIndex(
        (location) => location.locationMappingId === locationMappingId
      );
      if (matchedLocationIndex !== -1) {
        updatedLocationMappingData[matchedLocationIndex] = {
          ...updatedLocationMappingData[matchedLocationIndex],
          boundary
        };
      }
      return { ...state, localLocationMappingData: updatedLocationMappingData };
    }
    case ACTION_TYPES.SET_IS_OVERLAPPING_REGIONS:
      return { ...state, isOverlappingRegions: action.payload };
    case ACTION_TYPES.SET_DRAWING_IN_PROGRESS:
      return { ...state, drawingInProgress: action.payload };
    case ACTION_TYPES.SET_SELECTED_FEATURE_IDS_ON_MAP:
      return { ...state, selectedFeatureIdsOnMap: action.payload };
    case ACTION_TYPES.SUBMIT_LOCATION_START:
      return { ...state, isLocationUpdateInProgress: true };
    case ACTION_TYPES.SUBMIT_LOCATION_FINISH:
      return { ...state, isLocationUpdateInProgress: false, isOperationDelayed: false };
    case ACTION_TYPES.OPERATION_DELAYED:
      return { ...state, isOperationDelayed: true };
    case ACTION_TYPES.OPEN_LOCATION_MAPPING_FORM:
      return { ...state, selectedLocationCardId: action.payload };
    case ACTION_TYPES.CLOSE_FORM: {
      const { isNewLocationMapping, locationId, newSelectedFeatureIdsOnMap } = action.payload;
      let { selectedLocationCardId, isNewLocation, newLocationMappingInfo } = state;

      if (!isNewLocationMapping && locationId) {
        selectedLocationCardId = null;
      } else {
        isNewLocation = false;
        newLocationMappingInfo = null;
      }
      return {
        ...state,
        selectedLocationCardId,
        isNewLocation,
        newLocationMappingInfo,
        selectedFeatureIdsOnMap: newSelectedFeatureIdsOnMap,
        isOverlappingRegions: false
      };
    }
    case ACTION_TYPES.SET_SELECTED_LOCATION_CARD_ID:
      return { ...state, selectedLocationCardId: action.payload };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

export { initialState, locationMappingReducer, ACTION_TYPES };
